module.exports = __webpack_public_path__ + "yt.svg?95c61f4373e1152cb2eb0a57bc497e5b";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/yt.svg
// module id = 1228
// module chunks = 27